import React, { useState, useEffect } from "react";
import { Form, Input, Button, Typography, DatePicker, Row, Col, Spin, message, Card, Space } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import SidebarLayout from "./SidebarLayout";
import { routes } from "../../routes/Routes";
import { RightOutlined, UserOutlined, CalendarOutlined, DownloadOutlined, ExpandOutlined, IdcardOutlined, EditOutlined, CopyOutlined } from '@ant-design/icons';
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import _commonService from "../../modules/commonService";
import "../BankAdmin/BankAdminProfile.scss";
import ChangePasswordForm from "../BankAdmin/ChangePasswordForm";

const { Title, Text, Link } = Typography;

const BankerProfile = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [bankerInfo, setBankerInfo] = useState({});
    const BankerId = localStorage.getItem("BankerId");
    const BankerFirstName = localStorage.getItem("BankerFirstName");

    useEffect(() => {
        GetBankerInformationByBankerId();
    }, []);

    const GetBankerInformationByBankerId = async () => {
        try {
            setLoading(true);
            const res = await _BankerService.getBankerInformationByBankerId(BankerId);
            if (res?.data?.IsSuccess && res.data.Obj) {
                setLoading(false);
                setBankerInfo(res.data.Obj);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching banker information:", error);
        }
    };


    const onFinish = async (values) => {
        //history.push(routes.accountLogin.path);
        setLoading(true);
        try {
            const reqObj = {
                Email: bankerInfo.Email,
                OldPassword: values.currentPassword,
                NewPassword: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            const res = await _BankerService.ChangeBankerPassword(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                localStorage.setItem("Password", values.newPassword);
                form.resetFields();
                history.push(routes.bankerprofile.path);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        } finally {
            setLoading(false);

        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };
    const onPersonalEditClick = () => {
        history.push({
            pathname: routes.personalDetails.path,
            state: { BankerId: localStorage.getItem("BankerId"), isFromDashboard: true, },
        });
    }
    const onProfessionalEditClick = () => {
        history.push({
            pathname: routes.professionalDetails.path,
            state: { BankerId: localStorage.getItem("BankerId"), isFromDashboard: true, },
        });
    }
    return (
        <Spin spinning={loading}>
            <SidebarLayout>
                <Title level={4}>Hello, {BankerFirstName}!</Title>
                <Row gutter={[16, 16]}>
                    {/* Widened to full width now that Professional Details (below) is hidden for
                        Banker-role profiles -- see the commented-out Col right after this Card. */}
                    <Col xs={24} lg={12}>
                        <Card className="card-section userProfileCardView h100"
                            title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><UserOutlined /> </span>
                                        Personal Details
                                    </Text>
                                    <EditOutlined onClick={onPersonalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >
                            <Row gutter={[12, 24]}>
                                {/* <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Account Type:</Text>
                                    <br />
                                    <Text  className="b-bottm">{bankerInfo?.Role}</Text>
                                </Col> */}
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">First Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{bankerInfo.FirstName}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Middle Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{bankerInfo.MiddleInitial || "N/A"}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Last Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{bankerInfo.LastName}</Text>
                                </Col>

                                {/* <Col xs={12} sm={12} md={12} lg={12}>

                                    <Text type="secondary">Joined In</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {bankerInfo?.CreatedDate
                                            ? moment(bankerInfo.CreatedDate).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>

                                </Col> */}

                                {/* <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Date Of Birth:</Text>
                                    <br />
                                    <Text  className="b-bottm">
                                        {bankerInfo?.DateOfBirth
                                            ? moment(bankerInfo.DateOfBirth).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>
                                </Col> */}

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Email:</Text>
                                    <br />
                                    <Text className="b-bottm">{bankerInfo.Email}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Contact Number:</Text>
                                    <br />
                                    <Text className="b-bottm">{bankerInfo?.ContactNumber ? _commonService.formatUSPhoneNumber(bankerInfo.ContactNumber) : "N/A"}</Text>

                                </Col>

                                
                            </Row>
                        </Card>
                    </Col>


                    <Col xs={24} md={12} style={{ display: "flex" }}>
                        <Card className="card-section userProfileCardView" style={{ width: "100%", height: "100%" }}>
                            <Title level={5} style={{ fontSize: "18px", textAlign: "center", marginBottom: 16 }}>Change Password</Title>
                            <ChangePasswordForm
                                form={form}
                                onFinish={onFinish}
                                validatePassword={validatePassword}
                            />
                        </Card>
                    </Col>


                    {/* Professional Details is hidden for Banker-role profiles per the current
                        requirement (onboarding no longer stops on that screen either -- see
                        CreateNewPasswordForBanker.js). Left in place, commented out, rather than
                        deleted: the ProfessionalDetails screen/route/API this reads from is still
                        fully intact and reachable (e.g. from the onboarding flow's own routing),
                        so this section can be restored later by simply uncommenting it. */}
                    {/* <Col xs={24} lg={12}>
                        <Card className="card-section userProfileCardView"
                              title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><IdcardOutlined /> </span>
                                  Professional Details
                                    </Text>
                                    <EditOutlined onClick={onProfessionalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >

                            <Row gutter={[24, 24]} align="top">
                                <Col xs={24} md={14}>
                                    <Row gutter={[0, 16]}>
                                        <Col span={12}><Text type="secondary">Job Role:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{bankerInfo.JobRole}</Text></Col>

                                        <Col span={12}><Text type="secondary">Institution Name:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{bankerInfo.InstitutionName}</Text></Col>

                                        <Col span={12}><Text type="secondary">Street Address:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{bankerInfo.OfficeAddress}</Text></Col>

                                        <Col span={12}><Text type="secondary">City:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{bankerInfo.City}</Text></Col>

                                        <Col span={12}><Text type="secondary">State:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{bankerInfo.State}</Text></Col>

                                        <Col span={12}><Text type="secondary">Zip Code:</Text></Col>
                                        <Col span={12}><Text  className="b-bottm">{bankerInfo.ZipCode}</Text></Col>

                                        <Col span={12}><Text type="secondary">ID Number:</Text></Col>
                                        <Col span={12}><Text  className="b-bottm">{bankerInfo.IdentificationNumber}</Text></Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col> */}
                </Row>

                {/* <Row justify="center" style={{ marginTop: 25 }}>
                    <Col xs={24} md={12} style={{ display: "flex" }}>
                        <Card className="card-section userProfileCardView" style={{ width: "100%", height: "100%" }}>
                            <Title level={5} style={{fontSize: "18px", textAlign:"center", marginBottom: 16 }}>Change Password</Title>
                            <ChangePasswordForm
                                form={form}
                                onFinish={onFinish}
                                validatePassword={validatePassword}
                            />
                        </Card>
                    </Col>
                </Row> */}
            </SidebarLayout>
        </Spin>
    );
};

export default BankerProfile;
